
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      player: null,
      isSearchByName: false,
      namedPlayers: [],
    };
  },
  computed: {
    team () {
      return this.post.acf.player_page_config.team?.team?.[0];
    },
    season () {
      return this.post.acf.player_page_config.season?.season?.[0];
    },
    playerComparisonConfig () {
      return this.post.acf.player_page_config.player_comparison_block;
    },
    showPlayerComparison () {
      return this.post.acf.player_page_config.display.player_comparison;
    },
    showPlayerStats () {
      return this.post.acf.player_page_config.display.player_stats;
    },
    showMatchSummary () {
      return this.post.acf.player_page_config.display.match_summary;
    },
    comparisonTitle () {
      if (this.player) {
        const title = this.post.acf.player_page_config.player_comparison_title;
        const playerName = this.getKnownAs(this.player.player);
        return title.replace(`[NAME]`, playerName);
      }
      return ``;
    },
  },
  provide () {
    return {
      team: this.team,
      season: this.season,
      post: this.post,
    };
  },
  mounted () {
    this.$nextTick(() => {
      this.getPlayer();
    });
  },
  methods: {
    getPlayer () {
      if (this.$route.query.ref) {
        this.isSearchByName = false;
        const playerId = this.$route.query.ref;
        this.getPlayerById(playerId);
      } else if (this.$route.path.substring(this.$route.path.lastIndexOf(`/`) + 1)) {
        this.playerName = this.$route.path.substring(this.$route.path.lastIndexOf(`/`) + 1);
        this.isSearchByName = true;
        this.getPlayerByName();
      }
    },
    async getPlayerById (id) {
      const params = {
        include: `squad,player.sponsors.images,player.images,player.country.images`,
        filter: {
          "squad.seasonId": this.season.id,
          "playerId": id,
        },
      };
      const response = await this.$getStats(`playerSquad`, params);
      if (response !== null) {
        if (response.data.length) {
          this.player = response.data[0];
        } else {
          this.isSearchByName = true;
          this.noResults = true;
        }
      }
    },
    async getPlayerByName () {
      const params = {
        q: this.playerName.replace(`-`, ` `),
        entity: `player`,
      };

      const request = await this.$getSearchStats(params);
      if (request !== null) {
        this.namedPlayers = request.player;
        // TODO: double check that if 1 player returned display them?
      }
    },
  },
};
